import moment from "moment";

export const getEllipsesFromText = ({ text, length }) => {
  let formattedText = text;

  if (text?.length <= length) {
    return formattedText;
  }

  formattedText = formattedText?.substring(0, length);
  formattedText += "..";

  return formattedText;
};
